module.exports = "<p>\n  data-processing works!\n</p>\n"